import { styled } from "styled-components";

export const Button = styled.button`
  height: 40px;
  width: 120px;
  background-color: #383838;
  border: 1px solid #383838;
  border-radius: 50px;
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
`;
